/**
 * user agent string을 보고 TTS의 모니터링 툴 'WMS'의 접근인지 여부를 판단
 * @param userAgent 검사 대상이 될 ua string
 * @returns ua가 WMS인지 여부
 */
export function checkWmsUserAgent(userAgent: string) {
  return /^wms/gi.test(userAgent);
}
